Vue.component("asset-group-update-form", {

    props: {
        assetGroup: {},
        groupTypes: {}
    },

    data () {
        return {
            form: new AppForm({
                notes: this.assetGroup.notes,
                type: this.assetGroup.type,
                asset_group_name: this.assetGroup.name
            })
        };
    },

    methods: {

        saveAssetGroup () {
            App.patch("/assets/groups/" + this.assetGroup.id + "/update", this.form)
            .then((response) => {
                Bus.$emit("asset-group-updated", response);
                window.toastr.success("Saved!");
            });
        }

    }

});
